import { ShipmentTypeKeys } from '@utility/constants/common';
import { Link } from 'react-router';
import { PlusIcon } from '@phosphor-icons/react';
import { buttonStyles } from '@skupreme/shared/ui';

export function CreateShipmentButton({ supplierId, wholesaleView }) {
  const type = wholesaleView ? ShipmentTypeKeys.WS : ShipmentTypeKeys.PO;

  return (
    <Link
      to={`/app/scm/shipments/create?origin_id=${supplierId}&type=${type}&step=1`}
      className={buttonStyles({ className: 'sk:mt-3 sk:no-underline' })}
    >
      <PlusIcon aria-hidden size={16} />
      Shipment
    </Link>
  );
}
